import React, { ButtonHTMLAttributes, FC } from 'react';
import styles from '#components/controls/icon-button/IconButton.module.scss';
import clsx from 'classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  classes?: string;
  variant?: 'contained' | 'outlined' | 'transparent';
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  color?: 'secondary' | 'primary';
  transparent?: boolean;
  rounded?: boolean;
}

const IconButton: FC<Props> = ({
  classes = '',
  size = 'medium',
  transparent,
  variant,
  color,
  children,
  rounded = true,
  ...buttonProps
}) => {
  const classNames = clsx(
    styles.host,
    styles[size],
    styles[variant],
    styles[color],

    {
      [styles.transparent]: transparent === true,
      [styles.rounded]: rounded === true,
    }
  );

  return (
    <button className={`${classNames} ${classes}`} {...buttonProps}>
      {children}
    </button>
  );
};

export default IconButton;
